module.exports = __webpack_public_path__ + "static/media/fuel-filter-change-red.e70d6d15.svg";